document.addEventListener("DOMContentLoaded", () => {
  const calculateValues = () => {
    const length = parseFloat(document.getElementById("length").value);
    const width = parseFloat(document.getElementById("width").value);
    const depth = parseFloat(document.getElementById("depth").value);

    const linerlength = 2 * depth + length + 1;
    const linerwidth = Math.ceil((2 * depth + width + 1) / 5) * 5;

    const errorEl = document.getElementById("error");
    const linerlengthEl = document.getElementById("linerlength");
    const linerwidthEl = document.getElementById("linerwidth");

    if (isNaN(linerlength) || isNaN(linerwidth)) {
      errorEl.textContent = "Please fill out all inputs";
      linerlengthEl.value = "";
      linerwidthEl.value = "";
    } else {
      errorEl.textContent = "";
      linerlengthEl.value = linerlength;
      linerwidthEl.value = linerwidth;
    }
  };

  // Add change event listeners to the inputs
  const inputs = document.querySelectorAll("#length, #width, #depth");
  inputs.forEach((input) => {
    input.addEventListener("change", calculateValues);
  });

  // Add submit event listener to forms with class "calcflex"
  const forms = document.querySelectorAll(".calcflex");
  forms.forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      calculateValues();
    });
  });
});
